import React from 'react';
import { NumberInput } from 'react-admin';
import { getSourceAndLabel, getClassificationFromSource } from '../PositionRateSettingsForm.utils';
import {
  calculatedFieldPath,
  useRecordValueReader,
} from 'resources/rate_settings/utils/fieldsVisibility';
import { RateSettingsDisplayHelper } from 'utils/displayHelpers/rate-settings';
import { useFormContext } from 'react-hook-form';
import { getInheritedValue } from 'utils/rateSettings/SharedRateSettingsForm.utils';
import { PARENT_SETTINGS_FIELD } from '../constants';
import { W2BurdensTooltip } from 'resources/rate_settings/shared/W2BurdensTooltip';

type Props = {
  source: string;
  inheritedSettings: any;
};

export const MarginPercentInput = ({ source, inheritedSettings }: Props) => {
  const { getValues } = useFormContext();
  const parentSettings = getValues(PARENT_SETTINGS_FIELD);

  const recordValue = useRecordValueReader();
  const { label, field } = getSourceAndLabel(source);
  const inputSource = calculatedFieldPath(source, field, recordValue);
  const isFinalMargin = [
    'total_margin_percent_w2',
    'margin_percent_1099',
    'margin_percent_w2_travel',
  ].includes(field);
  const { tab } = getClassificationFromSource(source);
  const rateSettingsDisplayHelper = new RateSettingsDisplayHelper({ settings: inheritedSettings });
  const inheritedSettingsHash = rateSettingsDisplayHelper.getSettingsForClassification(tab);
  const inheritedW2Burdens = rateSettingsDisplayHelper.getW2Burdens();

  const parentSettingsHash = new RateSettingsDisplayHelper({ settings: parentSettings });
  const parentClassificationHash = parentSettingsHash.getSettingsForClassification(tab);
  const isW2Local = field === 'total_margin_percent_w2';

  return (
    <W2BurdensTooltip w2Burdens={inheritedW2Burdens} enabled={isW2Local && !!inheritedW2Burdens}>
      <NumberInput
        source={inputSource}
        label={label}
        helperText={String(
          getInheritedValue(inheritedSettingsHash, field, parentClassificationHash) || '',
        )}
        disabled={isFinalMargin}
      />
    </W2BurdensTooltip>
  );
};
